import React from 'react';
import {Button} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './FilterDrawerFooter.module.scss';

type FilterDrawerFooterProps = {
  onClearAll: () => void;
  onApply: () => void;
  clearAllDisabled?: boolean;
};

function FilterDrawerFooter({
  onClearAll,
  onApply,
  clearAllDisabled = false,
}: FilterDrawerFooterProps) {
  return (
    <div className={styles.footer}>
      <Button
        size="small"
        appearance="neutral"
        mode="plain"
        disabled={clearAllDisabled}
        onClick={onClearAll}
      >
        {translate('Clear All')}
      </Button>
      <Button
        size="medium"
        appearance="neutral"
        mode="filled"
        onClick={onApply}
      >
        {translate('Apply')}
      </Button>
    </div>
  );
}

export default FilterDrawerFooter;
